import { Component, Input, OnChanges } from '@angular/core';
import { SubrecipientStatusVm } from 'src/app/api.service';
import { MultiSelectOption } from '../multi-select/multi-select.component';

@Component({
  selector: 'subs-subaward-status-multi-select',
  template: `
    <subs-multi-select
      [controlName]="controlName"
      [labelLength]="labelLength"
      [containerStyle]="containerStyle"
      [options]="options"
    >
    </subs-multi-select>
  `,
})
export class SubawardStatusMultiSelectComponent implements OnChanges {
  @Input()
  controlName: string;

  @Input()
  containerStyle: string;

  @Input()
  labelLength: number;

  @Input()
  displayOSRSStatus = true;

  @Input()
  displayDAStatus = true;

  @Input()
  statuses: SubrecipientStatusVm[] = [];

  options: MultiSelectOption[] = [];

  ngOnChanges(): void {
    this.options = this.statuses
      .filter((status) => this.setDisplay(status))
      .map((status) => ({
        value: status.statusCode,
        label: status.statusDescription,
      }));
  }

  private setDisplay(status: SubrecipientStatusVm): boolean {
    return status.statusType === 'OSRS Status'
      ? this.displayOSRSStatus
      : this.displayDAStatus;
  }
}
